(() => { 

    let constants = {
        videoElement: "slider-element",
        close: "br-icon__close",
        prev: "br-icon__before",
        next: "br-icon__after",
        index: 0,
    }

    let videoElement = document.querySelectorAll(`.${constants.videoElement}`);

    const createVideo = (src, modal, modalVideo) => {
        //let modalVideo = document.createElement('video')
        modalVideo.src = src;
        modalVideo.controls = true;
        modalVideo.muted = false;
        modalVideo.height = 600; // in px
        modalVideo.width = 380;
        modal.append(modalVideo);
    }

    const deleteVideoElement = (video, modalWindow) => {
        video.remove();
        modalWindow.style.display = 'none';
        document.body.classList.remove('birdie-stop_scrolling');
    }

    const nextVideoElement = (video, modalWindowInner, modalVideo) => {

        //createVideo(videoElement[index+1].dataset.src, modalWindowInner, modalVideo)
    }

    const prevVideoElement = (video, modalWindowInner) => {
        video.remove()

        createVideo(videoElement[index-1].dataset.src, modalWindowInner)
    }

    const createVideoElement = (video, modalWindow, modalWindowInner) => {
        document.body.classList.add('birdie-stop_scrolling');
        let modalVideo = document.createElement('video')

        createVideo(video.querySelector('.video-element').dataset.src, modalWindowInner, modalVideo)

        modalWindow.style.display = 'flex';

        let iconClose = document.querySelector(`.${constants.close}`);
        let iconPrev = document.querySelector(`.${constants.prev}`);
        let iconNext = document.querySelector(`.${constants.next}`);


        iconClose.addEventListener('click', (e) => {

            deleteVideoElement(modalVideo, modalWindow);
        })

        iconPrev.addEventListener('click', () => {
            if ( constants.index == 0 ) {
                constants.index = videoElement.length - 1;
            } else {
                constants.index--;
            }

            let videoLast = document.querySelector('.video-container video')

            videoLast 
                && videoLast.remove()

            createVideo(videoElement[constants.index].querySelector('.video-element').dataset.src, modalWindowInner, modalVideo)
        })

        iconNext.addEventListener('click', () => {

            if ( constants.index == videoElement.length-1 ) {
                constants.index = 0;
            } else {
                constants.index++;
            }

            let videoLast = document.querySelector('.video-container video');


            videoLast 
                && videoLast.remove()

            createVideo(videoElement[constants.index].querySelector('.video-element').dataset.src, modalWindowInner, modalVideo)
        })
    }

   const preloadFunction = () => {
        let modalWindow = document.querySelector('.testimonials-container__modal');
        let modalWindowInner = document.querySelector('.video-container');

        Array.from(videoElement).forEach( (video, index) => {
            video.addEventListener( 'click', (e) => {
                //e.stopImmediatePropagation();
                console.log(modalWindow);

                if (modalWindow.childNodes.items) {
                    if (modalWindow.childNodes.items.length < 1) {
                        //createVideoElement(video)
                    }
                } else {
                    constants.index = index;
                    createVideoElement(video, modalWindow, modalWindowInner)
                }
            })
        })
   }
   preloadFunction()
})();
